"use client";

import AuthState from '../components/AuthState';
import FirebaseContext from '../lib/context/Firebase';
import Msal from '../lib/context/Msal';
import { PropsWithChildren } from 'react';

export default function ContextProvider({children}: PropsWithChildren) {
    return (
        <Msal>
            <FirebaseContext>
                <AuthState>
                    {children}
                </AuthState>
            </FirebaseContext>
        </Msal>
    )
}
